import { useQuery } from 'react-query';

import { cacheKeys } from 'config';
import { documentsClient } from 'clients/documents/documentsClient';


export type Params = {
  slug?: string;
  draft?: boolean;
};

type Options = {
  enabled: boolean;
};

const defaultOptions: Partial<Options> = {
  enabled: true,
};

export const useDocumentSearchDropdownData = (params: Params = {}, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, status, error } = useQuery(
    [cacheKeys.documents.getSearchDropdownData, params],
    () => documentsClient.getSearchDropdownData(params),
    {
      enabled: options.enabled,
    },
  );

  return {
    status,
    error,
    data,
  };
};
